import Vue from 'vue';
import newsTransformer from './../../transformers/news';
import paginationTransformer from '../../transformers/pagination';

const success = ({ data }, resolve) => {
  const items = newsTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  resolve({ items, pagination });
};

const failed = (error, reject) => reject(error);

export default (campaignId, page = 1, limit = 10) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`news?campaign_id=${campaignId}&page=${page}&limit=${limit}`)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/news/items.js